import React from "react";
import { useStoreState } from "easy-peasy";
import { Route } from "react-router-dom";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import FourOThree from "Pages/private/403";

const PrivateRoute = ({ component, authSubject, ...props }) => {
  const { abilities } = useStoreState((state) => state.auth);
  return (
    <Route
      {...props}
      render={(matchProps) =>
        AuthCheck(abilities, AUTH_ACTIONS.MENU, authSubject) ? (
          React.isValidElement(component) ? (
            component
          ) : (
            React.createElement(component)
          )
        ) : (
          <FourOThree />
        )
      }
    />
  );
};

export default PrivateRoute;
